import { Component, isDevMode } from '@angular/core';

import { Platform } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';
import { PlatformLocation } from '@angular/common';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss']
})
export class AppComponent {
  constructor(
    private platform: Platform,
    private splashScreen: SplashScreen,
    private statusBar: StatusBar,
    private platformLocation: PlatformLocation
  ) {
    this.initializeApp();
    const location = (this.platformLocation as any).location;
    if (!location.href.includes('http://localhost:8100')) {
      if ( navigator.userAgent.toLowerCase().indexOf('firefox') > -1 ) {
        if (document) {
          const ancestor = document.referrer;
          if (ancestor !== 'https://erp.jobinrwanda.com/') {
             document.location.href = 'https://www.jobinrwanda.com/contact';
          }
        } else {
          document.location.href = 'https://www.jobinrwanda.com/contact';
        }
      }
      if ((navigator.userAgent.toLowerCase().indexOf('chrome') > -1) || (navigator.userAgent.toLowerCase().indexOf('safari') > -1)  ){
        if (location.ancestorOrigins.length) {
          const ancestor = location.ancestorOrigins[0];
          if (ancestor !== 'https://erp.jobinrwanda.com') {
            document.location.href = 'https://www.jobinrwanda.com/contact';
          }
        } else {
          document.location.href = 'https://www.jobinrwanda.com/contact';
        }
      }

    }
  }

  initializeApp() {
    this.platform.ready().then(() => {
      this.statusBar.styleDefault();
      this.splashScreen.hide();
    });
  }
}
